import { render, staticRenderFns } from "./DhmeBillOfMaterialElements.vue?vue&type=template&id=547cd70c&scoped=true"
import script from "./DhmeBillOfMaterialElements.vue?vue&type=script&lang=js"
export * from "./DhmeBillOfMaterialElements.vue?vue&type=script&lang=js"
import style0 from "./DhmeBillOfMaterialElements.vue?vue&type=style&index=0&id=547cd70c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "547cd70c",
  null
  
)

export default component.exports